import React, { useRef, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { storageHandler } from "../../../Helpers";
export default function CartInfluencer({
  cartItemLoop,
  updateProfilePage,
  setUpdateProfilePage,
}) {
  const navigate = useNavigate();
  const showProfileForUSer = (userType, id) => {
    setUpdateProfilePage(!updateProfilePage);
    storageHandler.setUserTypeForProfileItem(JSON.stringify(userType));
    navigate("/brand/influencerProfile/" + id);
  };

  return (
    <div className="search-checkout-item">
      <img
        className="showProfileImgCursor"
        onClick={() =>
          showProfileForUSer(cartItemLoop.to_user_type, cartItemLoop.to_user_id)
        }
        src={
          cartItemLoop.profileImage && cartItemLoop.profileImage !== ""
            ? cartItemLoop.profileImage
            : `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`
        }
        onError={({ currentTarget }) => {
          currentTarget.onerror = null;
          currentTarget.src = `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`;
        }}
      />
      <div className="search-checkout-item-info-holder">
        <div className="search-checkout-item-title-holder">
          <div className="search-checkout-item-title">
            {cartItemLoop.offer_type == "custom"
              ? cartItemLoop.pieceOfContent
                ? cartItemLoop.pieceOfContent + " "
                : ""
              : ""}
            {cartItemLoop.product}

            {cartItemLoop.offer_type == "custom"
              ? cartItemLoop.time
                ? cartItemLoop.time !== ""
                  ? " (" + cartItemLoop.time + " " + cartItemLoop.timespan + ")"
                  : ""
                : ""
              : ""}
          </div>
          <div className="search-checkout-item-price text-green-700 text-sm">
            ${cartItemLoop.price}
          </div>
        </div>
        <div className="search-checkout-item-name">
          {cartItemLoop.profileName}{" "}
          {cartItemLoop.influencerAccountCount > 1 &&
            "(" + cartItemLoop.followers_count + " Followers)"}
        </div>
      </div>
    </div>
  );
}
